/**
 * 常量
 */
const PAGE_SIZE = 10 // 每页大小
const CURRENT_PAGE = 1 // 当前页

const LOADING_EFFECT = {
  text: '正在加载',
  color: '#4ea397',
  maskColor: 'rgba(255, 255, 255, 0.4)'
}

// 所有平台
const PLATFORMS = ['admin', 'agency', 'finance', 'ka', 'ad-user']
// 接口地址
const BASE_URL = (function () {
  if (VUE_APP_ENV === 'online') {
    if (VUE_APP_DATACENTER === 'xingguang') {
      return 'http://hotniuer2.xg.tagtic.cn'
    } else {
      return 'http://hotniuer2.xy.huijitrans.com'
    }
  } else {
    if (VUE_APP_DATACENTER === 'xingguang') {
      // return 'http://hotniuer2-build-3-4-x.xg.tagtic.cn'
      // return 'http://hotniuer2-build-2-6-2.xg.tagtic.cn'
      return 'http://hotniuer2.dev.tagtic.cn'
    } else {
      return 'http://hotniuer2.dev.huijitrans.com';
    }
  }
}())
// Cookie 相关
const COOKIE_USER = 'user'
const COOKIE_PWD = 'pwd'
const STORE_USER_ID = 'id'

// 正则网址
const REGEXP_URL = /[-a-zA-Z0-9@:%_\+.~#?&//=]{2,256}\.[a-z]{2,4}\b(\/[-a-zA-Z0-9@:%_\+.~#?&//=]*)?/gi

// 正则 http | https
const REGEXP_WEBSITE_URL = /^https?:\/\//

// 正则图片
const REGEXP_IMAGE = /\.(gif|jpg|jpeg|tiff|png)$/i

// 正则图标
const REGEXP_ICON = /\.(icon)$/i

// 正则视频
const REGEXP_VIDEO = /\.(avi|AVI|wmv|WMV|flv|FLV|mpg|MPG|mp4|MP4)$/i
const REGEXP_VIDEO_MP4 = /\.(mp4)$/i

export {
  PAGE_SIZE,
  CURRENT_PAGE,
  LOADING_EFFECT,
  PLATFORMS,
  BASE_URL,
  COOKIE_USER,
  COOKIE_PWD,
  STORE_USER_ID,
  REGEXP_URL,
  REGEXP_WEBSITE_URL,
  REGEXP_IMAGE,
  REGEXP_ICON,
  REGEXP_VIDEO,
  REGEXP_VIDEO_MP4
}
